// extracted by mini-css-extract-plugin
module.exports = {"container":"_1-MzD0","text":"_2gEzfD"};